import React, {Component} from 'react';
import {Link} from 'components/ReactRouterDomLocalized';

import {ErrorContainer, Form} from 'form';

import {t, dt} from 'l10n';

import {sendContactMessage} from 'backend-helpers/contacts';

const STANDBY = 'standby';
const PENDING = 'pending';
const FINISHED = 'finished';

class FormContacts extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            state: STANDBY
        };

        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(formData, setErrors) {
        if (this.state.state == PENDING) return false;

        this.setState({state: PENDING});

        sendContactMessage(formData)
            .then(() => {
                this.setState({state: FINISHED});
            })
            .catch((error) => {
                setErrors(error.messages || error.message);
                this.setState({state: STANDBY});
            });
    }

    componentWillUnmount() {
        this.setState({state: STANDBY});
    }
    
    render() {
        let {currentUser} = this.props;
        let {state} = this.state;

        let contents;
        switch (state) {
            case STANDBY:
            case PENDING:
                let pending = (state === PENDING);
                if (currentUser.isLoggedIn()) {
                    contents = <FormLoggedIn currentUser={currentUser} onSubmit={this.onSubmit} pending={pending}/>;
                } else {
                    contents = <FormUnlogged onSubmit={this.onSubmit} pending={pending}/>;
                }
                break;
            case FINISHED:
                contents = (
                    <div>
                        <p>{t('Your message has been sent successfully. It will be processed within 24 hours.')}</p>
                        <Link to="/" className="ui-button primary">{t('Return')}</Link>
                    </div>
                );
                break;
        }
    

        return (
            <aside className="form-contacts">
                <div className="content">
                    {contents}
                </div>
            </aside>
        )
    }
}

function FormLoggedIn({currentUser, onSubmit, pending}) {
    return (
        <Form className="form-user-contacts" onSubmit={onSubmit}>
            <ErrorContainer data-errorcontainer={true} />
            <div>
                <p>{t('Email:')}</p>
                <input type="email" name="email" className="ui-text-input" defaultValue={currentUser.email} required/>
            </div>
            <div>
                <p>{t('Message:')}</p>
                <textarea name="message" className="ui-text-input" required/>
            </div>

            {/*<div className="captcha"></div>*/}

            <button type="submit" className={'btn-submit' + (pending ? ' loading' : '')}>
                {dt('alt', 'Send')}
            </button>
        </Form>        
    );
}

function FormUnlogged({onSubmit, pending}) {
    return (
        <div className="form-user-contacts">
            <Form onSubmit={onSubmit}>
                <ErrorContainer data-errorcontainer={true} />

                <div>
                    <div>
                        <p>{t('Nick:')}</p>
                        <input name="nick" type="text" className="ui-text-input" required/>
                    </div>
                    <div>
                        <p>{t('Password:')}</p>
                        <input name="password" type="password" className="ui-text-input"/>
                    </div>
                </div>
                <div>
                    <div>
                        <p>{t('Email:')}</p>
                        <input name="email" type="email" className="ui-text-input" required/>
                    </div>
                    <div>
                        <p>{t('Status:')}</p>
                        <select name="member_type">
                            <option value="Gratuit">{t('Free')}</option>
                            <option value="XXL">{t('XXL')}</option>
                        </select>
                    </div>
                </div>
                <div>
                    <div>
                        <p>{t('Message:')}</p>
                        <textarea name="message" className="ui-text-input" required/>
                    </div>
                </div>

                {/*<div className="captcha"></div>*/}

                <button type="submit" className={'btn-submit' + (pending ? ' loading' : '')}>
                    {dt('alt', 'Send')}
                    </button>
            </Form>
        </div>        
    )
}

export default FormContacts;


// WEBPACK FOOTER //
// ./src/components/contacts/FormContacts.js